import { memo, useState } from 'react';

import { alertDanger } from '../styles/tw-components';

// NB - the alert bar scrolls. If we want to make it sticky we can use
// style={{ position: 'fixed', width: '100%' }} but the Amplify Login UI floats
// so that'll appear over top of it. Maybe that's better than not seeing it though?
// For padding shifts for navbar, eliminating gaps -- set top padding to zero for now
const stylesheet = {
    noContainer: 'tw:pt-0',
    dismissButton: 'tw:absolute tw:top-2 tw:right-2 tw:bg-transparent tw:border-none tw:text-xl tw:cursor-pointer tw:leading-none tw:opacity-50 tw:hover:opacity-100',
};

function AlertBar({
    message, inContainer = false, dismissible = false, style = {}, className,
}: { message: React.ReactNode; inContainer?: boolean; dismissible?: boolean; style?: React.CSSProperties; className?: string }) {
    const classString = [alertDanger, inContainer ? '' : stylesheet.noContainer, className].filter(Boolean).join(' ');
    const [show, setShow] = useState(true);

    if (show && message) {
        return (
            <div
              role="alert"
              className={classString}
              style={style}
            >
                {!inContainer && (<br />)}
                {message}
                {dismissible && (
                    <button
                      type="button"
                      className={stylesheet.dismissButton}
                      aria-label="Close"
                      onClick={() => setShow(false)}
                    >
                        &times;
                    </button>
                )}
            </div>
        );
    }
    return null;
}

export default memo(AlertBar);
